import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createIcon } from '@chakra-ui/icons';
export const HamburgIcon = createIcon({
    displayName: 'HamburgIcon',
    viewBox: '0 0 24 24',
    path: (_jsxs(_Fragment, { children: [_jsx("path", { d: "M4 18L20 18", stroke: "#1C1B1F", strokeWidth: "1", strokeLinecap: "round" }), _jsx("path", { d: "M4 12L20 12", stroke: "#1C1B1F", strokeWidth: "1", strokeLinecap: "round" }), _jsx("path", { d: "M4 6L20 6", stroke: "#1C1B1F", strokeWidth: "1", strokeLinecap: "round" })] })),
});
//# sourceMappingURL=hamburgIcon.js.map